module.exports = __webpack_public_path__ + "media/packs/images/flags/CR-270f2a5317826b277195f637ea99ad45.svg";